export const LOAD_DATA_EXTRA_LICENSE =
  'containers/ExtraLicense/LOAD_DATA_EXTRA_LICENSE';
export const LOAD_DATA_EXTRA_LICENSE_SUCCESS =
  'containers/ExtraLicense/LOAD_DATA_EXTRA_LICENSE_SUCCESS';
export const LOAD_DATA_EXTRA_LICENSE_ERROR =
  'containers/ExtraLicense/LOAD_DATA_EXTRA_LICENSE_ERROR';
